<template>
   <g class="arm600">
        <g class="armfront" data-name="armfront">
          <polygon class="innertop topside" data-name="innertop topside" points="1250.97 2878.47 1216.33 2858.47 1216.33 2818.47 1250.97 2838.47 1250.97 2878.47" fill="#5070af"/>
          <polygon class="innerright rightside" data-name="innerright rightside" points="1216.33 2818.47 1216.33 2858.47 1250.97 2838.47 1216.33 2818.47" fill="#365593"/>
        </g>
        <g class="armholder" data-name="armholder">
          <polygon class="armholder-front" data-name="armholder-front" points="1779.69 2615.72 1727.73 2585.72 1727.73 2465.72 1779.69 2495.72 1779.69 2615.72" fill="#7793bf"/>
          <polygon class="armholder-right" data-name="armholder-right-10px" points="1788.36 2610.72 1779.7 2615.72 1779.7 2495.72 1788.36 2490.72 1788.36 2610.72" fill="#3d6199"/>
        </g>
        <polygon class="toparm600 topside" data-name="toparm600 topside" points="1770.58 2538.47 1250.97 2838.47 1216.33 2818.47 1735.94 2518.47 1770.58 2538.47" fill="#5070af"/>
        <polygon class="rightarm600 rightside" data-name="rightarm600 rightside" points="1770.58 2578.47 1250.97 2878.47 1250.97 2838.47 1770.58 2538.47 1770.58 2578.47" fill="#365593"/>
        <g class="double-arm600" v-if="doubleBranch">
          <polygon class="armholder-right" data-name="armholder-right-10px" points="1814.33 2595.44 1805.67 2600.44 1805.67 2480.44 1814.33 2475.44 1814.33 2595.44" fill="#3d6199"/>
          <polygon class="darm600 rightside" data-name="darm600 rightside" points="1814.35 2553.2 2324.84 2258.47 2324.84 2218.47 1814.33 2513.22 1814.35 2553.2" fill="#365593"/>
          <polygon class="darm600 frontside" data-name="darm600 frontside" points="1814.33 2513.22 1814.34 2473.21 2290.2 2198.47 2324.84 2218.47 1814.33 2513.22" fill="#5e7cb7"/>
        </g>
      </g>
</template>
<script>
export default {
  props: {
    doubleBranch: Boolean,
  },

  name: "Arm600-B.vue",
};
</script>